export const ArrowForwardIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.75" clip-path="url(#clip0_2314_2858)">
      <path d="M6.99992 2.33337L6.17742 3.15587L9.43242 6.41671H2.33325V7.58337H9.43242L6.17742 10.8442L6.99992 11.6667L11.6666 7.00004L6.99992 2.33337Z" />
    </g>
    <defs>
      <clipPath id="clip0_2314_2858">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
